import { IGetTriggersResponse } from '../../../interfaces/api/ITriggers';
import {api} from '../api';

/**
 * it adds the triggers endpoint to the api
 * 
 * @returns TriggersRepository
 */
const TriggersRepository = api.injectEndpoints({
    endpoints: (build) => ({
        getTriggers: build.query<IGetTriggersResponse, void>({
            query: () => ({url: "/triggers", method: "GET"}),          
        }),
    }),
});

export const { useGetTriggersQuery } = TriggersRepository;